import { bankAccountApi } from '../../api'
import { useAuthQuery } from '@/hooks/use-auth-query'

export function useGetRecurringPayment() {
  return useAuthQuery({
    queryKey: ['recurring-payment'],
    queryFn: bankAccountApi.getRecurringPaymentV2,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
  })
}
